var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4429 15.3144L15.1279 18.0039L12.4414 20.6942L13.5034 21.7539L17.2534 18.0039L13.5034 14.2539L12.4429 15.3144Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6929 15.3144L20.3779 18.0039L17.6914 20.6942L18.7534 21.7539L22.5034 18.0039L18.7534 14.2539L17.6929 15.3144Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3502 5.25L12.001 10.338L4.65248 5.25H19.3502ZM10.501 17.25H3.00098L2.99873 5.9295L11.5742 11.8665C11.7025 11.9558 11.8517 12 12.001 12C12.151 12 12.2995 11.9558 12.4285 11.8665L21.0017 5.93175L21.001 12.75H22.501V5.25C22.501 4.42275 21.8282 3.75 21.001 3.75H3.00098C2.17448 3.75 1.50098 4.4205 1.50098 5.247V17.25C1.50098 18.0773 2.17448 18.75 3.00098 18.75H10.501V17.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSend);
export default __webpack_public_path__ + "static/media/email-send.0442b1a821bb905d25a1e8c2fe91062c.svg";
export { ForwardRef as ReactComponent };